let openChangeTeamDialogImpl: ((userId: string) => void) | undefined;

export function registerOpenChangeTeamDialog(
  impl: (userId: string) => void
): () => void {
  openChangeTeamDialogImpl = impl;
  return () => {
    if (openChangeTeamDialogImpl === impl) {
      openChangeTeamDialogImpl = undefined;
    }
  };
}

export function openChangeTeamDialog(userId: string): void {
  if (!openChangeTeamDialogImpl) {
    console.error("ChangeSlotTeamDialogHost is not mounted");
    return;
  }
  openChangeTeamDialogImpl(userId);
}
